import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BusListener, LibBusService, LibMessageBusListener } from 'ngx-mat-base-comp';
import { Subscription } from 'rxjs';

@BusListener(LibMessageBusListener.Main)
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'DrpHub';
  private sub = new Subscription();

  constructor(
    private libBusService: LibBusService,
    private translate: TranslateService
    ) {
      this.translate.setDefaultLang(this.libBusService.currentLanguage);
      this.translate.addLangs(['en', 'fr']);
      this.translate.use(this.libBusService.currentLanguage);

      this.sub.add(window.addEventListener("beforeunload", (event: any) => {
        if (libBusService.hasUnsavedChanges) {
          event.preventDefault();
          event.returnValue = "Unsaved modifications";
          return event;
        }
     }));

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  
}
